/* eslint-disable react/prop-types */
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import Helmet from '@s-ui/react-head'
import AdDisplay from '@adv-mt/mt-ad-display'
import Layout from '@adv-mt/mt-layout-basic'
import ListMakes from '@adv-mt/mt-list-makes'
import Breadcrumb from '@adv-mt/mt-navigation-breadcrumb'
import SectionWrapper from '@adv-mt/mt-shared-section-wrapper'
import MotorTrackingCriteo from '@adv-mt/mt-tracking-criteo'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../components/LinkFactory/index.js'
import {getInitialProps} from './getInitialProps.js'

const TechnicalDetailsHome = ({
  breadcrumb,
  domain,
  helmet = {},
  i18n,
  makesList = [],
  pageName,
  serverErrors,
  loadThirdParties
}) => {
  const config = domain.get('config')
  const APP_NAME = config.get('APP_NAME')
  const {TECHNICAL_DETAILS_SEARCH_PATH_PATTERN: technicalDetailsSearchPathPattern} = config.get('page')

  const hasErrors = Boolean(serverErrors.length)

  const featuredMakesList = makesList.filter(make => make.isMostSearched)

  return (
    !hasErrors && (
      <Layout.Basic linkFactory={LinkFactory} as="main">
        <h1 className="mt-TechnicalDetailsHome-title">{i18n.t(`TECHNICAL_DETAILS_HOME_${APP_NAME}_TITLE`)}</h1>
        <SectionWrapper title={i18n.t(`TECHNICAL_DETAILS_HOME_${APP_NAME}_SUBTITLE_TOP_MAKES`)}>
          <ListMakes makes={featuredMakesList} linkFactory={LinkFactory} isFeatured />
        </SectionWrapper>
        <SectionWrapper title={i18n.t(`TECHNICAL_DETAILS_HOME_${APP_NAME}_SUBTITLE_ALL_MAKES`)} hasBackground>
          <ListMakes makes={makesList} linkFactory={LinkFactory} isFeatured={false} />
          <div className="mt-TechnicalDetailsHome-searchLinkWrapper">
            <AtomButton
              color="primary"
              link
              linkFactory={LinkFactory}
              href={technicalDetailsSearchPathPattern}
              shape={atomButtonShapes.CIRCULAR}
              design={atomButtonDesigns.OUTLINE}
            >
              {i18n.t('TECHNICAL_DETAILS_HOME_SEARCH_LINK')}
            </AtomButton>
          </div>
        </SectionWrapper>
        <Breadcrumb items={breadcrumb} linkFactory={LinkFactory} />

        {loadThirdParties && (
          <>
            <Helmet {...helmet} />
            <TrackingPageView pageName={pageName} />
            <AdDisplay pageName={pageName} />
            <MotorTrackingCriteo />
          </>
        )}
      </Layout.Basic>
    )
  )
}

TechnicalDetailsHome.displayName = 'TechnicalDetailsHome'

TechnicalDetailsHome.propTypes = {
  initialTechnicalDetailsHome: PropTypes.object,
  params: PropTypes.object,
  domain: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  loadThirdParties: PropTypes.bool
}

TechnicalDetailsHome.getInitialProps = getInitialProps

export default TechnicalDetailsHome
